'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGIcon = require('ad-react-components/lib/SVGIcon');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _genericResult = require('../generic-result');

var _genericResult2 = _interopRequireDefault(_genericResult);

var _service = require('./service.scss');

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    result: _propTypes2.default.shape({
        type: _propTypes2.default.string,
        label: _propTypes2.default.string,
        count: _propTypes2.default.integer,
        query: _propTypes2.default.string
    }).isRequired,
    searchQuery: _propTypes2.default.string.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    index: _propTypes2.default.number.isRequired,
    highlightIndex: _propTypes2.default.number,
    savedQuery: _propTypes2.default.string.isRequired,
    setResultSelection: _propTypes2.default.func.isRequired,
    getContainerRect: _propTypes2.default.func.isRequired,
    scrollIntoView: _propTypes2.default.func.isRequired
};

var defaultProps = {
    highlightIndex: -1
};

var ServiceResult = function (_React$Component) {
    _inherits(ServiceResult, _React$Component);

    function ServiceResult() {
        _classCallCheck(this, ServiceResult);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    ServiceResult.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.highlightIndex !== this.props.highlightIndex && this.props.index === this.props.highlightIndex) {
            this.props.setResultSelection(this.getResultQuery());
        }
    };

    ServiceResult.prototype.getResultQuery = function getResultQuery() {
        var _props = this.props,
            savedQuery = _props.savedQuery,
            searchQuery = _props.searchQuery,
            result = _props.result;

        return (savedQuery || searchQuery) + ' in ' + result.label;
    };

    ServiceResult.prototype.render = function render() {
        var _this2 = this;

        return _react2.default.createElement(
            _genericResult2.default,
            {
                onClick: function onClick() {
                    _this2.props.onClick(_this2.getResultQuery());
                },
                index: this.props.index,
                highlightIndex: this.props.highlightIndex,
                getContainerRect: this.props.getContainerRect,
                scrollIntoView: this.props.scrollIntoView
            },
            _react2.default.createElement(
                'div',
                { className: _service2.default.icon },
                _react2.default.createElement(_SVGIcon2.default, { type: 'search', width: _service2.default.iconSize, fill: _service2.default.iconColor })
            ),
            _react2.default.createElement(
                'div',
                { className: _service2.default.content },
                _react2.default.createElement(
                    'span',
                    { className: _service2.default.searchTermLabel },
                    this.props.savedQuery || this.props.searchQuery
                ),
                '\xA0in\xA0',
                _react2.default.createElement(
                    'span',
                    { className: _service2.default.serviceLabel },
                    this.props.result.label
                ),
                '\xA0(',
                this.props.result.count,
                ')'
            )
        );
    };

    return ServiceResult;
}(_react2.default.Component);

exports.default = ServiceResult;


ServiceResult.propTypes = propTypes;
ServiceResult.defaultProps = defaultProps;